import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DRAFT_SAVED_BANNER_MESSAGE, TemplatePublishStatus } from './templatePublishStatus';
import { RequestPublishButton } from './RequestPublishButton';
import { ReactComponent as InfoIcon } from '../../shared/icons/info-unfilled-icon.svg';
import './TemplateDraftBanner.scss';

interface TemplateDraftBannerProps {
  templateId: string;
  publishStatus: TemplatePublishStatus;
  templateName?: string;
  publishRequestedAt?: string | null;
  canEdit: boolean;
  canPublish: boolean;
}

/**
 * Tells a template editor who cannot publish that their saves stay in the
 * draft. Publishers already see the Publish button, and viewers have no
 * edits to explain, so it renders nothing for them.
 */
export const TemplateDraftBanner = ({
  templateId,
  publishStatus,
  templateName,
  publishRequestedAt = null,
  canEdit,
  canPublish,
}: TemplateDraftBannerProps) => {
  if (!canEdit || canPublish || publishStatus === 'published') return null;

  return (
    <div className="template-draft-banner" role="status" data-testid="template-draft-banner">
      <div className="template-draft-banner__content">
        <InfoIcon className="template-draft-banner__icon" aria-hidden="true" />
        <span className="template-draft-banner__text">
          <FormattedMessage id="template.draft-banner.message" defaultMessage={DRAFT_SAVED_BANNER_MESSAGE} />{' '}
          <RequestPublishButton
            templateId={templateId}
            templateName={templateName}
            publishRequestedAt={publishRequestedAt}
          />
        </span>
      </div>
    </div>
  );
};
